const STORAGE_KEY = 'marketing_params';

export function isMarketingParam(key: string): boolean {
  return key.startsWith('utm_');
}

export default defineNuxtRouteMiddleware((to, from) => {
  if (process.server) return;

  const stored = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}');
  for (const [key, value] of Object.entries({ ...to.query, ...from?.query })) {
    if (isMarketingParam(key) && typeof value === 'string') stored[key] = value;
  }
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(stored));

  const merged = { ...stored, ...to.query };
  if (Object.keys(merged).length <= Object.keys(to.query).length) return;

  return navigateTo({
    path: to.path,
    query: merged,
    hash: to.hash,
    replace: true,
  });
});
